import type { QueryClient } from '@tanstack/react-query';
import { create } from 'zustand';

import type { Entitlements } from '~sf/models';

import {
  DEFAULT_ENTITLEMENT_MAP,
  EntitlementActionMap,
  generateEntitlementMap,
} from './entitlements/generateEntitlementMap';

export type State = {
  // Auth
  checkedAuth: boolean;
  loggedIn: boolean;
  onlineStatus: boolean;
  entitlementsChecked: boolean;

  // Profile info
  entitlements: Entitlements[];
  entitlementMap: EntitlementActionMap;

  authenticate: (
    {
      loggedIn,
      onlineStatus,
    }: {
      loggedIn: boolean;
      onlineStatus: boolean;
    },
    queryClient: QueryClient,
  ) => void;

  setEntitlements: (entitlements: Entitlements[]) => void;
};

const useStore = create<State>((set, get) => ({
  checkedAuth: false,
  loggedIn: false,
  entitlementsChecked: false,
  onlineStatus: true,

  entitlements: [],
  entitlementMap: DEFAULT_ENTITLEMENT_MAP,

  // Updates
  authenticate: (data, queryClient) => {
    if (!data) {
      return;
    }

    const wasLoggedIn = get().loggedIn;

    set({
      ...data,
      checkedAuth: true,
    });

    if (!data.loggedIn) {
      if (wasLoggedIn && queryClient) {
        // reset query cache when logging in as it could be a different user from the last time
        queryClient.clear();
      }
    }
  },

  setEntitlements: (entitlements) => {
    const entitlementMap = generateEntitlementMap(entitlements);
    set({ entitlements, entitlementMap, entitlementsChecked: true });
  },
}));

export default useStore;
